<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  <div class="white-space-normal flex flex-wrap gap-1">
    @for (author of cellData; track author) {
      @if (author.count === 1) {
        <span>{{ author.count }}</span>
      }
      @if (author.count > 1) {
        <a href="#"
           (click)="filterByAuthor($event, author.memberId)">{{ author.count }}</a>
      }
    }
  </div>
</ng-template>